"use client";
import { j as l } from "./jsx-runtime-CJ-St4mQ.mjs";
import { u as ue, a as Ae, d as De, e as Se } from "./NavigationMenu.style-Dq96CLFG.mjs";
import { C as ke } from "./chevron-down-YJUEXrSs.mjs";
import * as s from "react";
import * as te from "react-dom";
import { u as He, F as oe, i as ne, g as je, b as ze, a as Ve } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { u as W } from "./useEventCallback-CjuAhyNz.mjs";
import { u as se } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { v as Le } from "./visuallyHidden-DPuANzJJ.mjs";
import { u as _e } from "./useTimeout-BRUciAq6.mjs";
import { a as q, u as $e } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { u as Be } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as ce } from "./NavigationMenuItemContext-CXLOapAH.mjs";
import { u as We, a as qe, b as Ge, t as Ke } from "./translateOpenChangeReason-C857LgAi.mjs";
import { P as Ue, u as Ze } from "./useRenderElement-B8V3_e8R.mjs";
import { a as Je, t as Qe } from "./popupStateMapping-Cl0RMVD6.mjs";
import { i as Xe } from "./isOutsideMenuEvent-QttO0YQ0.mjs";
import { N as p, a as w, g as re } from "./NavigationMenuPositionerCssVars-DZFKlrfE.mjs";
import { C as Ye } from "./CompositeItem-DhB3Tdag.mjs";
import { u as et } from "./FloatingTree-vWe5pGqE.mjs";
import { u as tt, s as ot } from "./safePolygon-9xumQ2iN.mjs";
import { u as nt } from "./useButton-CQeWQM5o.mjs";
import { g as st, c as rt } from "./element-DE7VsBMX.mjs";
import { s as it } from "./event-CXjJudzK.mjs";
const ie = "data-base-ui-navigation-menu-trigger", ae = {
  width: 0,
  height: 0
}, at = new AbortController(), le = /* @__PURE__ */ s.forwardRef(function(m, g) {
  const {
    className: E,
    render: b,
    nativeButton: A = !0,
    disabled: D,
    ...S
  } = m, {
    value: d,
    setValue: u,
    mounted: T,
    open: c,
    positionerElement: i,
    setActivationDirection: G,
    setFloatingRootContext: K,
    popupElement: o,
    viewportElement: y,
    rootRef: U,
    beforeOutsideRef: k,
    afterOutsideRef: pe,
    afterInsideRef: H,
    beforeInsideRef: ge,
    prevTriggerElementRef: j,
    delay: me,
    closeDelay: de,
    orientation: M,
    setViewportInert: he
  } = ue(), R = ce(), ve = Ae(), ye = et(), N = _e(), z = q(), V = q(), L = q(), [f, Re] = s.useState(null), [Ee, Z] = s.useState(!0), [_, J] = s.useState(""), C = s.useRef(!1), P = s.useRef(ae), x = s.useRef(at), r = c && d === R, Q = Be(r), $ = i ? !0 : !d, be = $e(o);
  s.useEffect(() => {
    x.current.abort();
  }, [r]);
  const X = W(() => {
    o && (o.style.setProperty(p.popupWidth, "auto"), o.style.setProperty(p.popupHeight, "auto"));
  }), h = W((e, t) => {
    if (!o || !i)
      return;
    o.style.removeProperty(p.popupWidth), o.style.removeProperty(p.popupHeight), i.style.removeProperty(w.positionerWidth), i.style.removeProperty(w.positionerHeight);
    const {
      width: n,
      height: a
    } = re(o);
    (t === 0 || e === 0) && (e = n, t = a), o.style.setProperty(p.popupWidth, `${e}px`), o.style.setProperty(p.popupHeight, `${t}px`), i.style.setProperty(w.positionerWidth, `${n}px`), i.style.setProperty(w.positionerHeight, `${a}px`), V.request(() => {
      o.style.setProperty(p.popupWidth, `${n}px`), o.style.setProperty(p.popupHeight, `${a}px`), L.request(() => {
        x.current = new AbortController(), be(X, x.current.signal);
      });
    });
  });
  s.useEffect(() => {
    c || (N.clear(), V.cancel(), L.cancel(), P.current = ae);
  }, [N, c, V, L]), s.useEffect(() => {
    if (!o || typeof ResizeObserver != "function")
      return;
    const e = new ResizeObserver(() => {
      P.current = {
        width: o.offsetWidth,
        height: o.offsetHeight
      };
    });
    return e.observe(o), () => {
      e.disconnect();
    };
  }, [o]), s.useEffect(() => {
    if (!o || !r || typeof MutationObserver != "function")
      return;
    const e = new MutationObserver(() => {
      x.current.abort(), h(P.current.width, P.current.height);
    });
    return e.observe(o, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      e.disconnect();
    };
  }, [o, i, r, h, X]), s.useEffect(() => (r && c && o && C.current && (C.current = !1, z.request(() => {
    var e;
    (e = k.current) == null || e.focus();
  })), () => {
    z.cancel();
  }), [k, z, h, r, c, o]), se(() => {
    Q.current && c && o && h(0, 0);
  }, [Q, c, o, h]);
  function Te(e, t, n) {
    const a = n === "trigger-hover";
    if (!$ || _ === "touch" && a || !e && d !== R)
      return;
    function O() {
      a && (Z(!0), N.clear(), N.start(Ue, () => {
        Z(!1);
      })), e ? u(R, t, n) : (u(null, t, n), J(""));
    }
    a ? te.flushSync(O) : O();
  }
  const v = He({
    open: c,
    onOpenChange(e, t, n) {
      Te(e, t, Ke(n));
    },
    elements: {
      reference: f,
      floating: i || y
    }
  }), Me = tt(v, {
    move: !1,
    handleClose: ot({
      blockPointerEvents: _ !== "touch"
    }),
    restMs: T && i ? 0 : me,
    delay: {
      close: de
    }
  }), Ne = We(v, {
    enabled: $,
    stickIfOpen: Ee,
    toggle: r
  }), Ce = qe(v, {
    enabled: r && $,
    outsidePress(e) {
      const t = st(e);
      return (t == null ? void 0 : t.closest(`[${ie}]`)) === null;
    }
  });
  se(() => {
    r && (K(v), j.current = f);
  }, [r, v, K, j, f]);
  const {
    getReferenceProps: Pe
  } = Ge([Me, Ne, Ce]);
  function Y(e) {
    te.flushSync(() => {
      var n;
      const t = (n = j.current) == null ? void 0 : n.getBoundingClientRect();
      if (T && t && f) {
        const a = f.getBoundingClientRect(), O = a.left > t.left, Fe = a.top > t.top;
        M === "horizontal" && a.left !== t.left ? G(O ? "right" : "left") : M === "vertical" && a.top !== t.top && G(Fe ? "down" : "up");
      }
      e.type !== "click" && (v.dataRef.current.openEvent = void 0), !(_ === "touch" && e.type !== "click") && d != null && u(R, e.nativeEvent, e.type === "mouseenter" ? "trigger-hover" : "trigger-press");
    });
  }
  const B = W((e) => {
    if (!o || !i) {
      Y(e);
      return;
    }
    const {
      width: t,
      height: n
    } = re(o);
    Y(e), h(t, n);
  }), xe = s.useMemo(() => ({
    open: r
  }), [r]);
  function ee(e) {
    J(e.pointerType);
  }
  const Ie = {
    tabIndex: 0,
    onMouseEnter: B,
    onClick: B,
    onPointerEnter: ee,
    onPointerDown: ee,
    "aria-expanded": r,
    "aria-controls": r ? o == null ? void 0 : o.id : void 0,
    [ie]: "",
    onFocus() {
      r && he(!1);
    },
    onMouseMove() {
      C.current = !1;
    },
    onKeyDown(e) {
      C.current = !0;
      const t = M === "horizontal" && e.key === "ArrowDown", n = M === "vertical" && e.key === "ArrowRight";
      (t || n) && (u(R, e.nativeEvent, "list-navigation"), B(e), it(e));
    },
    onBlur(e) {
      i && o && Xe({
        currentTarget: e.currentTarget,
        relatedTarget: e.relatedTarget
      }, {
        popupElement: o,
        rootRef: U,
        tree: ye,
        nodeId: ve
      }) && u(null, e.nativeEvent, "focus-out");
    }
  }, {
    getButtonProps: Oe,
    buttonRef: we
  } = nt({
    disabled: D,
    focusableWhenDisabled: !0,
    native: A
  }), I = i || y;
  return /* @__PURE__ */ l.jsxs(s.Fragment, {
    children: [/* @__PURE__ */ l.jsx(Ye, {
      tag: "button",
      render: b,
      className: E,
      state: xe,
      customStyleHookMapping: Je,
      refs: [g, Re, we],
      props: [Pe, Ie, S, Oe]
    }), r && /* @__PURE__ */ l.jsxs(s.Fragment, {
      children: [/* @__PURE__ */ l.jsx(oe, {
        ref: k,
        onFocus: (e) => {
          var t;
          if (I && ne(e, I))
            (t = ge.current) == null || t.focus();
          else {
            const n = je(f);
            n == null || n.focus();
          }
        }
      }), /* @__PURE__ */ l.jsx("span", {
        "aria-owns": y == null ? void 0 : y.id,
        style: Le
      }), /* @__PURE__ */ l.jsx(oe, {
        ref: pe,
        onFocus: (e) => {
          if (I && ne(e, I)) {
            const t = H.current && ze(H.current) ? H.current : f;
            t == null || t.focus();
          } else {
            const t = Ve(f);
            t == null || t.focus(), rt(U.current, t) || u(null, e.nativeEvent, "focus-out");
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (le.displayName = "NavigationMenuTrigger");
const fe = /* @__PURE__ */ s.forwardRef(function(m, g) {
  const {
    className: E,
    render: b,
    ...A
  } = m, D = ce(), {
    open: S,
    value: d
  } = ue(), u = S && d === D, T = s.useMemo(() => ({
    open: u
  }), [u]);
  return Ze("span", m, {
    state: T,
    ref: g,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, A],
    customStyleHookMapping: Qe
  });
});
process.env.NODE_ENV !== "production" && (fe.displayName = "NavigationMenuIcon");
const wt = (F) => {
  const { children: m, className: g, ...E } = F, b = typeof g == "function" ? g({ open: !1 }) : g;
  return /* @__PURE__ */ l.jsxs(
    le,
    {
      className: De({ class: b }),
      ...E,
      children: [
        m,
        /* @__PURE__ */ l.jsx(fe, { className: Se(), children: /* @__PURE__ */ l.jsx(ke, { size: 18 }) })
      ]
    }
  );
};
export {
  wt as default
};
